export default __webpack_public_path__ + "static/media/logoAurea.2ece42e6.png";